import React from "react";
import ProfilePicture from "./ProfilePicture";
import { formatDoctorName } from "../lib/utils/formatDoctorName";

const HospitalCard = ({
  logo,
  name,
  qualification,
  specialization,
  docCount,
  gender,
  handlePress,
  selected,
  is_active,
  selectionNumber,
  hide_from_tv,
  show_name_prefix,
}: {
  logo: string;
  name: string;
  docCount: string;
  qualification?: string;
  specialization?: string;
  gender?: string;
  handlePress: React.MouseEventHandler<HTMLButtonElement> | undefined;
  selected?: boolean;
  is_active?: boolean;
  selectionNumber?: number;
  hide_from_tv?: boolean;
  show_name_prefix?: boolean;
}) => {
  // Hide the card if hide_from_tv is true
  if (hide_from_tv === true) {
    return null;
  }

  const displayName =
    show_name_prefix === undefined
      ? name
      : formatDoctorName(name, show_name_prefix);

  return (
    <button className="w-full max-w-[300px] rounded-lg" onClick={handlePress}>
      <div
        className={`relative flex flex-col items-center justify-center w-full h-[180px] sm:h-[200px] p-3 sm:p-5 cursor-pointer border-2 ${
          selected
            ? "border-[#0F3CBE]"
            : "border-transparent hover:border-[#0F3CBE]"
        } ${docCount === "none" ? "rounded-lg" : "rounded-t-lg"}`}
        style={{ background: "rgba(0, 0, 0, 0.1)" }}
      >
        {selectionNumber && (
          <div className="absolute top-2 left-2 w-6 h-6 bg-[#0F3CBE] text-white text-md p-1 font-bold flex items-center justify-center rounded-full ring-2 ring-white">
            {selectionNumber}
          </div>
        )}

        {is_active ? (
          <div className=" absolute top-2 right-2 bg-white/20 backdrop-blur-sm rounded-full px-2 py-0.5 border border-[#55a630] shadow-lg">
            <div className="flex items-center">
              <div className="w-2 h-2 bg-[#55a630] rounded-full  shadow-lg mr-2"></div>
              <span className="text-[#55a630]  text-xs">Active</span>
            </div>
          </div>
        ) : (
          <div className=" absolute top-2 right-2 bg-white/20 backdrop-blur-sm rounded-full px-2 py-0.5 border border-[#859197] shadow-lg">
            <div className="flex items-center">
              <div className="w-2 h-2 bg-[#859197] rounded-full  shadow-lg mr-2"></div>
              <span className="text-[#859197]  text-xs">Inactive</span>
            </div>
          </div>
        )}
        {logo.startsWith("http") ? (
          <img
            className={`w-12 h-12 sm:w-16 sm:h-16 rounded-full`}
            src={logo}
            alt="hospital-logo"
          ></img>
        ) : (
          <ProfilePicture
            username={name}
            className="!w-12 !h-12 sm:w-16 sm:h-16 rounded-full"
            gender={gender}
          />
        )}
        <p className="text-lg sm:!text-xl md:text-base mt-3 sm:mt-4">
          {displayName}
        </p>
        <p className="text-gray-600 mt-1 sm:mt-2 text-sm sm:text-md">
          {" "}
          {qualification}
        </p>
        <p className="text-gray-600 mt-1 sm:mt-2 text-sm sm:text-md">
          {" "}
          {specialization}
        </p>
      </div>
      {docCount !== "none" && (
        <div className="bg-white flex justify-between rounded-b-lg p-3 sm:p-5">
          <p className="font-medium text-docDetail text-xs sm:text-sm">
            Number of Doctors
          </p>
          <p className="font-semibold text-dark text-xs sm:text-sm">
            {docCount}
          </p>
        </div>
      )}
    </button>
  );
};

export default HospitalCard;
